
import React from "react";

const TypingIndicator: React.FC = () => {
  return (
    <div className="flex items-center justify-start py-3 px-4">
      <span className="typing-dot"></span>
      <span className="typing-dot"></span>
      <span className="typing-dot"></span>
    </div>
  );
};

export default TypingIndicator;
